import React from 'react';
import styled from 'styled-components';

import {pxToEm} from '../../components/globalStyles';
import HexagonIconImage from '../../components/hexagonIconImage';
import WrapperAppUl from '../../components/wrapperAppUl';
import {ICloudEncodingNoteworthyFeature} from '../../data/cloudEncodingNoteworthyFeatureData';

//#region Styled Components

const StyledWrapper = styled.div`
  display: flex;
`;

const StyledTextWrapperDiv = styled.div`
  margin-left: ${pxToEm(39)}em;
`;

const StyledH3 = styled.h3`
  font-size: ${pxToEm(21)}em;
  margin: 0;
`;

const descriptionFontSizePx = 16;
const StyledDescriptionP = styled.p`
  font-size: ${pxToEm(descriptionFontSizePx)}em;
  line-height: 2;
  text-align: justify;
  margin: ${pxToEm(19) / pxToEm(descriptionFontSizePx)}em 0;
`;

const listItemFontSizePx = 12;
const StyledListItem = styled.li`
  font-size: ${pxToEm(listItemFontSizePx)}em;
  line-height: 2;
  text-align: justify;
  margin: ${pxToEm(19) / pxToEm(listItemFontSizePx)}em 0;
`;

//#endregion

interface Props {
  feature: ICloudEncodingNoteworthyFeature;
  salesDemoId?: string;
  className?: string;
}

const NoteworthyFeature: React.FunctionComponent<Props> = ({feature, salesDemoId, className}) => {
  return (
    <StyledWrapper className={className}>
      <HexagonIconImage iconSrc={feature.iconPath} />
      <StyledTextWrapperDiv>
        <StyledH3>{feature.name}</StyledH3>
        <StyledDescriptionP>{feature.description}</StyledDescriptionP>
        <WrapperAppUl>
          {feature.bullets.map((bullet, key) => (
            <StyledListItem key={key}>{bullet}</StyledListItem>
          ))}
        </WrapperAppUl>
      </StyledTextWrapperDiv>
    </StyledWrapper>
  );
};

export default NoteworthyFeature;
